<template>
  <div class="authorized-requests-view">
    <div class="container-fluid px-4 py-4">
      <!-- Header with Return Button -->
      <div class="d-flex align-items-center justify-content-between mb-4 w-100">
        <div>
          <h2 class="color-primary-4 font-weight-bold mb-0">
            Solicitudes Autorizadas
          </h2>
        </div>
        <action-button
          class="btn-warning-outline outline-warning px-4 py-2"
          i="fa fa-arrow-left"
          text="Volver"
          @click="onReturnHandler"
        />
      </div>

      <!-- Admin Access Check -->
      <div v-if="!isUserRoleAdmin" class="alert alert-warning">
        <i class="fas fa-exclamation-triangle mr-2"></i>
        Se requiere acceso de administrador para ver esta página
      </div>

      <!-- Report Content -->
      <div v-else>
        <authorized-requests-report />
      </div>
    </div>
  </div>
</template>

<script>
//mixins
import { userMixin } from '@/mixins/user.mixin.js';

//components
import ActionButton from 'ActionButton';
import AuthorizedRequestsReport from './components/AuthorizedRequestsReport.vue';

//utils
import { i18n } from '@/i18n.js';

export default {
  name: 'AuthorizedRequestsView',
  mixins: [userMixin],
  components: {
    ActionButton,
    AuthorizedRequestsReport,
  },
  mounted() {
    // Set sitemap breadcrumb
    this.$store.commit('app/SET_SITEMAP_INFO', {
      routes: [i18n.t('Home'), 'Reportes', 'Solicitudes Autorizadas'],
    });
  },
  methods: {
    onReturnHandler() {
      this.$router.push({ name: 'reports' });
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/bootstrap/_colors.scss';
@import '@/scss/components/action-button/index.scss';

.authorized-requests-view {
  min-height: calc(100vh - 200px);
}
</style>
